const digest = '517bbb53c6012ba0bb31638eea07242f58399181a096747e9e35df9e40f9f127';
const css = `._shortSilentVideoModal_14pm3_1 {
  position: relative;
  overflow: hidden;
  background-color: var(--ds-377, #ffffff);
}
._shortSilentVideoModal_14pm3_1 [role=dialog] {
  height: 100%;
  /* Override the DLS Modal's max-height or the bottom of the content will be cut off on
   * wide screens. On Chrome, this is best seen on "Laptop L" sizing. */
  max-height: 100%;
}

._videoSize_14pm3_13 {
  aspect-ratio: 16/9;
  min-height: min(768px, 100vh);
}
@media (max-width: 800px) {
  ._videoSize_14pm3_13 {
    max-width: 95vw;
    max-height: 95vh;
  }
}
@media (min-width: 800px) {
  ._videoSize_14pm3_13 {
    max-width: min(95vw, 1440px);
    max-height: min(95vh, 810px);
  }
}
@media (min-width: 800px) and (min-aspect-ratio: 16/9) {
  ._videoSize_14pm3_13 {
    height: min(95vh, 810px);
  }
}
@media (min-width: 800px) and (not (min-aspect-ratio: 16/9)) {
  ._videoSize_14pm3_13 {
    width: min(95vw, 1440px);
  }
}

._bottomLeft_14pm3_40 {
  left: 0;
  bottom: 0;
}

._back1_14pm3_45 {
  z-index: -1;
}

._transparent_14pm3_49 {
  background-color: transparent;
}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'shortSilentVideoModal': '_shortSilentVideoModal_14pm3_1', 'videoSize': '_videoSize_14pm3_13', 'bottomLeft': '_bottomLeft_14pm3_40', 'back1': '_back1_14pm3_45', 'transparent': '_transparent_14pm3_49' };
export const shortSilentVideoModal = '_shortSilentVideoModal_14pm3_1';
export const videoSize = '_videoSize_14pm3_13';
export const bottomLeft = '_bottomLeft_14pm3_40';
export const back1 = '_back1_14pm3_45';
export const transparent = '_transparent_14pm3_49';
export { css, digest };